export default __webpack_public_path__ + "static/media/AvenirNextLTPro-MediumCn.cbd454b4.woff";